import { Category } from './types';

export const categories: Category[] = [
  {
    id: 'phone-accessories',
    name: 'Phone Accessories',
    slug: 'phone-accessories',
    icon: 'Smartphone',
    description: 'Cases, chargers, holders & cables',
    productCount: 10,
    subcategories: [
      { id: 'phone-cases', name: 'Phone Cases', slug: 'phone-cases' },
      { id: 'chargers', name: 'Chargers & Cables', slug: 'chargers-cables' },
      { id: 'holders', name: 'Holders & Mounts', slug: 'holders-mounts' },
    ],
  },
  {
    id: 'smart-home',
    name: 'Smart Home',
    slug: 'smart-home',
    icon: 'Tv',
    description: 'Cameras, smart plugs, robot vacuum & doorbell',
    productCount: 8,
    subcategories: [
      { id: 'security-cameras', name: 'Security Cameras', slug: 'security-cameras' },
      { id: 'smart-devices', name: 'Smart Devices', slug: 'smart-devices' },
      { id: 'cleaning', name: 'Robot Cleaners', slug: 'robot-cleaners' },
    ],
  },
  {
    id: 'audio-wearables',
    name: 'Audio & Wearables',
    slug: 'audio-wearables',
    icon: 'Heart',
    description: 'Headphones, earbuds, speakers & smart watches',
    productCount: 8,
    subcategories: [
      { id: 'headphones', name: 'Headphones & Earbuds', slug: 'headphones-earbuds' },
      { id: 'speakers', name: 'Speakers', slug: 'speakers' },
      { id: 'smartwatches', name: 'Smart Watches', slug: 'smart-watches' },
    ],
  },
  {
    id: 'lighting',
    name: 'Lighting & Decor',
    slug: 'lighting',
    icon: 'Laptop',
    description: 'LED strips, night lights, ring lights & projectors',
    productCount: 9,
    subcategories: [
      { id: 'led-strips', name: 'LED Strip Lights', slug: 'led-strips' },
      { id: 'ring-lights', name: 'Ring & Fill Lights', slug: 'ring-lights' },
      { id: 'mood-lights', name: 'Mood & Night Lights', slug: 'mood-lights' },
    ],
  },
];

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find((cat) => cat.slug === slug);
};

export const getCategoryById = (id: string): Category | undefined => {
  return categories.find((cat) => cat.id === id);
};
